import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract" }, null, -1)

import { ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  /** Tiền tố hiển thị, vd: HD/ */
  prefix?: string;
  maxLength?: number;
  /** Tự viết hoa */
  uppercase?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractNumberInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập số hợp đồng" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    prefix: { default: "" },
    maxLength: { default: 50 },
    uppercase: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

const normalize = (value: string) => {
  let next = value.replace(/[^\w\-\/]/g, "");
  if (props.uppercase) next = next.toUpperCase();
  return next.slice(0, props.maxLength);
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = normalize(val ?? "");
  },
  { immediate: true }
);

const onInput = (val: string) => {
  const next = normalize(val);
  displayValue.value = next;
  emit("update:modelValue", next);
  emit("change", next);
};

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxLength,
    status: _ctx.status,
    "addon-before": _ctx.prefix || undefined,
    class: "ant-contract-number-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status", "addon-before"]))
}
}

})